import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeCartItem } from '../../../actions/v3Order';
import { selectOrderOptInMap } from '../../../selectors';
import styled from 'styled-components';

// TODO: move to a more generic styling file
const RemoveLink = styled.a`
  color: #479de6;
  display: block;
  width: 100%;
  padding-top: 8px;
  &:hover {
    color: #479de6;
  }
`;

// `studentId` is the row's ORDER KEY (`<eventId>-<studentId>`), which is what
// makes the per-order gate below possible: a bonus row may only be removed
// when the studio that awarded it is opt-in, whatever gallery the parent
// opened last (ENG-2043 R6).
const CartItemRemoveButton = ({ cartItem, studentId }) => {
  const dispatch = useDispatch();
  const orderOptInMap = useSelector(selectOrderOptInMap);

  if (cartItem?.isIncentive && !orderOptInMap[studentId]) {
    return null;
  }

  return (
    <RemoveLink
      onClick={() => dispatch(removeCartItem(cartItem.id, studentId))}
      className="bnl-cart-item__remove cursor-pointer"
    >
      Remove
    </RemoveLink>
  );
};

export default CartItemRemoveButton;
